/* tslint:disable:max-line-length */
import { DownOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

type ArrowDirection = 'right' | 'left' | 'up' | 'down';

const degreeMap = {
  right: 270,
  left: 90,
  up: 180,
  down: 360,
};

export const ArrowStatefulIcon = ({
  className,
  color = '#938BB7',
  onClick,
  direction = 'right',
  size = 20,
  style: propStyles,
}: IconTypeProps & {
  direction?: ArrowDirection;
  size?: number;
}) => {
  const style = {
    transform: `rotate(${degreeMap[direction]}deg)`,
    transition: '.3s',
    fontSize: size,
    cursor: 'pointer',
    color,
    ...propStyles,
  };

  return (
    <DownOutlined
      onClick={onClick}
      className={classNames(className, 'c-arrow-stateful-icon')}
      style={style}
    />
  );
};
